import React from "react";
import Styles from "../style.module.css";
import { MdKeyboardArrowRight } from "react-icons/md";


function BigImage() {
  return (
    <div className={Styles.banner}>
      <div className="text-white flex flex-col items-center h-full justify-center gap-y-14">
        <h1 className="uppercase md:text-5xl sm:text-3xl">Lorem Ipsum dolor sit</h1>
        <p className="sm:text-sm text-center w-1/2">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates
          iusto repellendus doloremque nihil voluptatibus illo sequi accusantium
          assumenda laborum itaque. Dolorem sit consequuntur sed repudiandae cum
          ducimus quam similique iure? Lorem ipsum dolor sit amet consectetur
        </p>
        <button className="flex justify-center border-2 rounded-md transition ease-in-out delay-150 border-white hover:bg-second md:w-40 sm:w-32 px-7 py-3">
          Ətraflı
          <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
        </button>
      </div>
    </div>
  );
}

export default BigImage;
